export default function PaymentTable({
  payments,
  templateColumns,
  actionColumns,
  updatePaymentField,
  deletePayment,
  showActions,
  canDelete
}) {
  const getPaymentValue = (payment, column) => {
    if (column.key) {
      return payment[column.key];
    }

    return payment.extra_fields?.[column.id] || "";
  };

  const formatPaymentValue = (payment, column) => {
    const value = getPaymentValue(payment, column);

    if (column.key === "amount") {
      return `${Number(value || 0).toLocaleString()} ₸`;
    }

    return value;
  };

  return (
    <div className="table-wrapper">

      <table className="table">

        <thead>
          <tr>
            {templateColumns.map((column) => (
              <th key={column.id}>{column.label}</th>
            ))}
            {showActions && actionColumns.map((column) => (
              <th key={column.id}>{column.label}</th>
            ))}
            {canDelete && <th></th>}
          </tr>
        </thead>

        <tbody>

          {payments.map(p => (

            <tr key={p.id}>
              {templateColumns.map((column) => (
                <td key={column.id}>{formatPaymentValue(p, column)}</td>
              ))}

              {showActions && actionColumns.map((column) => (
                <td key={column.id}>
                  <select
                    className="action-select"
                    value={p.extra_fields?.[column.id] || ""}
                    onChange={(e) => {
                      updatePaymentField(p.id, column.id, e.target.value);
                    }}
                    aria-label={`${column.label} для ${p.payment_number}`}
                  >
                    <option value="">Выбрать</option>
                    {column.options.map((option) => (
                      <option key={option.id} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </td>
              ))}

              {canDelete && (
                <td className="delete-cell">
                  <button
                    className="delete-btn"
                    aria-label="Удалить платеж"
                    title="Удалить платеж"
                    onClick={() => deletePayment(p.id)}
                  >
                    &#128465;
                  </button>
                </td>
              )}
            </tr>

          ))}

        </tbody>

      </table>

    </div>
  );
}
